import "./ImgScaler.css";
import React, { Component } from "react";
import ImageLoader from "./common/ImageLoader";
import { FaQuestionCircle } from "react-icons/fa";

class Unclip extends Component {
    constructor(props) {
        super(props);
        this.myRef = React.createRef();
        this.cropperRef = React.createRef();
    }

    uploadFileButton = () => {
        if (this.props.handleUploadInitImage !== null) {
            this.myRef.current.click();
        }
    };

    handleUploadFileEvent = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const url = URL.createObjectURL(file);
        this.props.handleUploadInitImage(file, url);
    };

    render() {
        return (
            <div className="scaler-container">
                <div style={{ color: "white", textAlign: "center", fontSize: "10pt", margin: "5px" }}>
                    {"Unclip Image "}
                    <FaQuestionCircle
                        size={15}
                        onClick={() =>
                            window.alert(
                                "Unclip is a feature that enables the expansion of image content. Using artificial intelligence, it generates objects beyond the original image's borders, ensuring these additions are consistent with the rest of the image. Please note, during this process, there might be variations in the details from the original image but the general aspects of it will remain."
                            )
                        }
                        style={{ verticalAlign: "middle", cursor: "pointer" }}
                    />
                </div>

                {this.props.loading ? <ImageLoader /> : null}

                <div style={{ width: "100%", height: "80%", textAlign: "center" }}>
                    <img
                        src={this.props.initImageURL}
                        alt="GeneratedImage"
                        className="scaler-image"
                        style={{ cursor: "pointer" }}
                        onClick={this.uploadFileButton}
                    />
                </div>

                {/* ✅ FIX: this element was missing */}
                <input
                    type="file"
                    accept="image/*"
                    ref={this.myRef}
                    style={{ display: "none" }}
                    onChange={this.handleUploadFileEvent}
                />

                <div
                    className="button-upscale"
                    onClick={() => this.props.submit(this.props.prompt)}
                >
                    {" Submit"}
                </div>
            </div>
        );
    }
}

export default Unclip;
